import { render, staticRenderFns } from "./Cplist.vue?vue&type=template&id=63e08396"
import script from "./Cplist.vue?vue&type=script&lang=js"
export * from "./Cplist.vue?vue&type=script&lang=js"
import style0 from "./Cplist.vue?vue&type=style&index=0&id=63e08396&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports